import React from "react";
import { StyledCModal } from "../../components/Modals";
import styled from "styled-components";
import { Fonts, Palette } from "../../components/utils";
import { Flex } from "../../components/ui/Flex";
import { ReactComponent as RoyalBankOfCanada } from "../../assets/icons/RBC_bank_logo.svg";
import { ReactComponent as BankOfAmerica } from "../../assets/icons/bank_of_america_logo.svg";
import { ReactComponent as BMOBank } from "../../assets/icons/bmo_bank.svg";
import { ReactComponent as CIBCBank } from "../../assets/icons/cibc_bank.svg";
import { ReactComponent as ScotiaBank } from "../../assets/icons/scotia_bank.svg";
import { ReactComponent as TDBank } from "../../assets/icons/td_bank.svg";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { closeActiveModal } from "../../helper/modals";
import { clearPaymentData } from "../../redux/actions/payments";
import { store } from "../..";
import { Card } from '../../components/ui/Card.jsx';

export const closeAndClearPaymentData = () => {
  closeActiveModal()
  store.dispatch(clearPaymentData())
}

export const PAYMENT_BANK_OPTIONS = [
  {
    id: 1,
    name: "Royal Bank of Canada",
    backgroundColor: '#1B52A8',
    logo: <RoyalBankOfCanada />,
    institutionNumber: '003'
  },
  {
    id: 2,
    name: "Toronto Dominion Bank",
    backgroundColor: '#54B948',
    logo: <TDBank />,
    institutionNumber: '004'
  },
  {
    id: 3,
    name: "Scotiabank",
    backgroundColor: '#E51E16',
    logo: <ScotiaBank />,
    institutionNumber: '002'
  },
  {
    id: 4,
    name: "Bank of Montreal",
    backgroundColor: '#0078C1',
    logo: <BMOBank />,
    institutionNumber: '001'
  },
  {
    id: 5,
    name: "Bank of America",
    backgroundColor: '#FFFFFF',
    logo: <BankOfAmerica />,
    institutionNumber: '241'
  },
  {
    id: 6,
    name: "CIBC",
    backgroundColor: '#B81830',
    logo: <CIBCBank />,
    institutionNumber: '010'
  }
]

export const PaymentModal = styled(StyledCModal)`
  .modal-dialog .modal-content {
    ${({ padding }) => padding ? `padding: ${padding} !important;` : `padding: 1.5rem !important;`}
  }  

  --input-font-weight: 400;
  --input-font-size: 14px;
  --input-height: 48px;
  --input-padding: 16px;

  input:not(
      .react-select__input input,
      .ant-picker-input input,
      .ant-select-selection-search-input
    ),
  .ant-select .ant-select-selector {
    padding-left: var(--input-padding);
    height: var(--input-height) !important;
  }

  &:not(.ant-select-customize-input)
    .ant-select-selector
    .ant-select-selection-search
    .ant-select-selection-search-input {
    height: var(--input-height);
    padding-left: 5px;
    font-size: var(--input-font-size);
    font-weight: var(--input-font-weight);
  }

  input,
  .ant-select .ant-select-selector {
    border-radius: 8px !important;
  }

  .react-select__control,
  .react-select__value-container {
    height: var(--input-height) !important;
  }

  .react-select__control .react-select__input input {
    font-size: var(--input-font-size) !important;
  }

  .ant-picker {
    height: var(--input-height);
    padding-left: var(--input-padding);
  }

  input,
  textarea,
  .ant-select .ant-select-selector .ant-select-selection-item,
  .ant-select .ant-select-selector .ant-select-selection-placeholder,
  .react-select__control,
  .react-select__single-value {
    font-weight: var(--input-font-weight);
    font-size: var(--input-font-size);
  }

  .react-select__option {
    font-size: var(--input-font-size);
  }

  .ant-picker-input input {
    font-size: var(--input-font-size) !important;
    font-weight: var(--input-font-weight) !important;
  }

  input::placeholder,
  .ant-select .ant-select-selector .ant-select-selection-item,
  .ant-select .ant-select-selector .ant-select-selection-placeholder {
    color: ${Palette.CONTENT_TERTIARY};
  }

  .react-select__control {
    padding-left: var(--input-padding);
  }

  textarea {
    padding-left: var(--input-padding);
  }
`

export const TitleText = styled.p`
  color: ${Palette.BLACK};

  font-family: ${Fonts.RED_HAT_FONT};
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 800;
  line-height: 2rem;
  letter-spacing: 0rem;
  margin: 0;

  ${({ lg }) =>
    lg &&
    `
    font-size: 1.5rem;
    line-height: 2.5rem;
  `}
`

export const DescriptionText = styled.p`
  color: ${Palette.BLACK};
  text-align: center;

  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0rem;
  margin: 0;
`

export const ModalButtonsContainer = styled(Flex)`
  width: 100%;
  padding: 0;
  padding-top: 1rem;
  gap: 0.5rem;
  justify-content: end;

  ${({ column }) =>
    column && `flex-direction: column;`}
`;

export const LightBlueText = styled.p`
  color: ${Palette.OCEANIC};

  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5rem;
  letter-spacing: 0rem;
  margin: 0;
`

export const StepItem = styled.div`
  width: 1.6875rem;
  height: 0.375rem;
  border-radius: 15px;

  ${({ filled }) =>
    filled ? `background-color: ${Palette.OCEANIC};` : `background-color: ${Palette.BRAND_DARK_BLUE};`}
`

export const IconBackground = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 100%;
  position: relative;

  ${({ background }) =>
    background && `background-color: ${background};`}
`

export const CurrencyInputContainer = styled.div`
  position: relative;

  &:has(input:not(:placeholder-shown))::before {
    content: '$';
    position: absolute;
    left: 17px;
    top: 50%;
    transform: translateY(-50%);
    color: ${Palette.BLACK_50};
    pointer-events: none;
    z-index: 1;
    font-weight: 400;
    font-size: 0.91rem;
  }

  /* Default padding when empty/showing placeholder */
  input {
    padding-left: 16px !important;
  }

  /* Increased padding when there's content */
  input:not(:placeholder-shown) {
    padding-left: 26px !important;
  }

    /* Apply focus styles to input */
  input:focus {
    background-color: ${Palette.WHITE};
    color: ${Palette.BLACK};
    outline: none;
    border: ${Palette.BORDER_OUTLINE} solid 0.5px !important;

    ::placeholder {
      color: ${Palette.BLACK};
    }
  }

  /* Update $ color when input is focused */
  &:has(input:focus)::before {
    color: ${Palette.BLACK}; /* or whatever color you want for focused state */
  }
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 11.6rem auto;
  gap: 1.5rem;

  ${({ gap }) =>
    gap &&
    `
    gap: ${gap};
  `}
`

export const OptionText = styled.p`
  text-transform: capitalize; 
  color: ${Palette.BLACK};

  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0rem;
  margin: 0;

  ${({ cssOverride }) => cssOverride};
`

export const LoadingSpinner = styled(AiOutlineLoading3Quarters)`
  animation: spin 1s linear infinite;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ModalContainer = styled.div`
  position: relative;

  ${({ padding }) =>
    padding &&
    `
    padding: ${padding} !important;
  `}
`;

export const BlurOverlay = styled.div`
  border-radius: 29px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px);
  background: rgba(255, 255, 255, 0.7);
  justify-content: center;
  align-items: center;
  z-index: 1000;
  pointer-events: auto;

  ${({ isVisible }) =>
    isVisible ? `display: flex;` : `display: none;`}
`;

export const ProcessingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
  color: #333;
  font-weight: 600;
`;
